<template>
    <v-autocomplete
        class="calcs"
        :disabled="searchDisabled"
        :items="filteredCalcs"
        :loading="loading"
        item-title="text"
        item-value="document"
        :label="searchLabel"
        v-on:keyup.enter="enter"
        :filter="filterFunc"
        v-model:search="search"
        return-object
        @update:search="searchItems"
        @blur="reset"
        prepend-inner-icon="mdi-magnify"
        density="compact"
        hide-no-data
        color="secondary"
        item-color="secondary"
        variant="outlined"
        ref="autocomplete"
    >
        <template v-slot:item="{ item, props }">
            <v-list-item v-bind="props" :to="calcHref(item)" link>
                <template v-slot:prepend>
                    <v-avatar>
                        <v-icon
                            v-if="item && item.document && item.document.calcId"
                        >
                            mdi-vector-polyline mdi-rotate-90
                        </v-icon>
                        <v-icon v-else>mdi-magnify</v-icon>
                    </v-avatar>
                </template>
                <v-list-item-title class="text-wrap">{{
                    item.title
                }}</v-list-item-title>
                <template v-slot:append>
                    <v-btn
                        v-if="
                            item && item.document && item.document.libraryName
                        "
                        class="mx-4 text-uppercase text-body-small"
                        variant="outlined"
                        size="small"
                        color="secondary"
                        disabled
                    >
                        {{ item.document.libraryName }}
                    </v-btn>
                    <v-btn
                        v-else
                        variant="outlined"
                        size="small"
                        disabled
                        class="mx-4 text-uppercase text-body-small"
                    >
                        All libraries
                    </v-btn>
                </template>
            </v-list-item>
        </template>
    </v-autocomplete>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

const autocomplete = ref(null)
const search = ref(null)
const filteredCalcs = ref([])
const loading = ref(false)
const latestSearch = ref('')

const searchDisabled = computed(
    () => import.meta.env.VUE_APP_ENABLE_SEARCH === 'false'
)
const searchLabel = computed(() =>
    searchDisabled.value ? 'Search disabled' : 'Search calculation'
)

function calcHref(item) {
    if (item?.document && !item.document.first) {
        if (item.document.persistentCalcId)
            return `/persistentCalcs/${item.document.persistentCalcId}`
        else return `/calcs/${item.document.calcId}`
    } else {
        const searchTerm = (search.value ?? '').replaceAll('/', ' ')
        return `/search/${searchTerm}`
    }
}

function enter() {
    let s = (search.value ?? '').replaceAll(' ', '-').replaceAll('/', ' ')
    router.push({ path: `/search/${s}` })
    autocomplete.value.blur()
}

function filterFunc() {
    return true
}

function reset() {
    latestSearch.value = ''
    filteredCalcs.value = []
    loading.value = false
}

async function searchItems(val) {
    loading.value = true
    if (val !== '' && val !== null) {
        latestSearch.value = val
        const searching = val
        let suggestions = await store.dispatch('suggestSearch', val)
        if (latestSearch.value === searching) {
            filteredCalcs.value = Array.isArray(suggestions) ? suggestions : []
            filteredCalcs.value.unshift({
                text: val,
                document: { first: true },
            })
        }
        loading.value = false
        return
    }
    reset()
}
</script>

<style>
.calcs .v-input__control {
    display: contents !important;
}
.v-menu__content {
    width: 100% !important;
}
.calcs .v-input__details {
    display: none;
}
</style>
